import { gql } from '@apollo/client'

/** Whether a new campaign may use one Advantage+ leads campaign budget, and the ad account minimum. */
export const ADVANTAGE_LEADS_OPTIONS = gql`
    query AdvantageLeadsOptions($campaignId: String!, $publisherId: String!, $objective: CampaignObjective!) {
        AdCampaign {
            advantageLeadsOptions(campaignId: $campaignId, publisherId: $publisherId, objective: $objective) {
                available
                reason
                message
                min_daily_budget
                min_spend_share
                bid_strategy
            }
        }
    }
`
